import ComponentsMoudel from '../factory/components/ComponentsMoudel';

const requer = new ComponentsMoudel();
export const axios = {
  get(url, params,openLoad=true) {
    let data = params ? Object.entries(params).reduce((arr, [k, v]) => arr.concat(encodeURIComponent(k) + '=' + encodeURIComponent(v)), []).join('&') : '';
    return requer.startGet(`${url}${data ? '?' + data : ''}`, params, openLoad)
  },
  post(url, params, isFormData) {
    if (isFormData) {
      let formdata = new FormData();
      Object.keys(params || {}).forEach(v => {
        if (params[v] !== null && params[v] !== undefined) {
          formdata.append(v, params[v])
        }
      })
      return requer.startPost(url, formdata, true)
    } else {
      return requer.startPost(url, params, true)
    }
  },
  delete(url, params) {
    return requer.startDel(url, params, true)
  }
}